export const FETCH_ALERTS = 'alert/FETCH_ALERTS';
export const FETCH_ALERT_BY_CAUSE = 'alert/FETCH_ALERT_BY_CAUSE';
export const SET_ALERT_BY_CAUSE = 'alert/SET_ALERT_BY_CAUSE';
